import { format } from "date-fns";
import countriesData from "../../../country.json";

interface Country {
	name: string;
	code: string;
	capital: string;
}

export const _renderBackground = (
	tags: "company_event" | "leave" | "holiday" | "birthday" | "anniversary"
) => {
	switch (tags) {
		case "company_event":
			return {
				border: "border-l-opus-green-500",
				background: "bg-opus-green-600",
				icon: "bg-opus-green-500",
			};
		case "leave":
			return {
				border: "border-l-opus-blue-200",
				background: "bg-opus-purple-100",
				icon: "bg-opus-blue-200",
			};
		case "holiday":
			return {
				border: "border-l-opus-blue-100",
				background: "bg-opus-blue-500",
				icon: "bg-opus-blue-100",
			};
		case "birthday":
			return {
				border: "border-l-opus-red-200",
				background: "bg-opus-red-100",
				icon: "bg-opus-red-200",
			};
		case "anniversary":
			return {
				border: "border-l-opus-yellow-200",
				background: "bg-opus-yellow-100",
				icon: "bg-opus-yellow-200",
			};
	}
};

export const formatDateRange = (startDate: Date, endDate: Date) => {
	if (startDate.toDateString() === endDate.toDateString()) {
		const formattedDate = format(startDate, "MMMM d, yyyy");
		return formattedDate;
	}

	const startMonth = format(startDate, "MMMM");
	const startDay = format(startDate, "d");
	const endDay = format(endDate, "d");
	const year = format(startDate, "yyyy");
	return `${startMonth} ${startDay}-${endDay}, ${year}`;
};

export const getCountryCode = (name: string): string | null => {
	const country = (countriesData as Country[]).find(
		(country) => country.name.toLowerCase() === name.toLowerCase()
	);
	return country ? country.code : null;
};

export const getCountryCapital = (name: string): string | null => {
	const country = (countriesData as Country[]).find(
		(country) => country.name.toLowerCase() === name.toLowerCase()
	);
	return country ? country.capital : null;
};
